"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginalExamAbbreviation = exports.SittingSeason = exports.QuestionType = exports.PivotType = exports.ComputationType = void 0;
var ComputationType;
(function (ComputationType) {
    ComputationType["Points"] = "points";
    ComputationType["Percentage"] = "percentage";
})(ComputationType || (exports.ComputationType = ComputationType = {}));
var PivotType;
(function (PivotType) {
    PivotType["Topic"] = "Topic";
    PivotType["QuestionType"] = "Question Type";
})(PivotType || (exports.PivotType = PivotType = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["math"] = "math";
    QuestionType["qualitative"] = "qualitative";
    QuestionType["synthesis"] = "synthesis";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
var SittingSeason;
(function (SittingSeason) {
    SittingSeason["fall"] = "fall";
    SittingSeason["spring"] = "spring";
})(SittingSeason || (exports.SittingSeason = SittingSeason = {}));
var OriginalExamAbbreviation;
(function (OriginalExamAbbreviation) {
    OriginalExamAbbreviation["GHADV"] = "GHADV";
    OriginalExamAbbreviation["GHCORU"] = "GHCORU";
    OriginalExamAbbreviation["GHDP"] = "GHDP";
    OriginalExamAbbreviation["GHDPA"] = "GHDPA";
    OriginalExamAbbreviation["GHDPC"] = "GHDPC";
    OriginalExamAbbreviation["GHFVA"] = "GHFVA";
    OriginalExamAbbreviation["GHFVCU"] = "GHFVCU";
    OriginalExamAbbreviation["GHFVU"] = "GHFVU";
    OriginalExamAbbreviation["GHSPC"] = "GHSPC";
    OriginalExamAbbreviation["GHVR"] = "GHVR";
    OriginalExamAbbreviation["GHRM"] = "GHRM";
})(OriginalExamAbbreviation || (exports.OriginalExamAbbreviation = OriginalExamAbbreviation = {}));
//# sourceMappingURL=types.js.map